import { apiMillennium } from '../../api'

const AwaitBoarding = async () => {
	const res = await apiMillennium.get('/ag-embarque')
	return res
}

export default AwaitBoarding